function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from 'react';
var BREAKPOINT = 768;
export function useResponsive() {
    var _useState = _sliced_to_array(useState(false), 2), isMobile = _useState[0], setIsMobile = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), showSidebar = _useState1[0], setShowSidebar = _useState1[1];
    useEffect(function() {
        var checkMobile = function() {
            var mobile = window.innerWidth < BREAKPOINT;
            setIsMobile(mobile);
            // 모바일에서는 사이드바 숨김, 데스크톱에서는 표시
            if (mobile) {
                setShowSidebar(false);
            } else {
                // 데스크톱에서는 localStorage에서 사이드바 상태 복원
                var savedState = localStorage.getItem('sidebar');
                setShowSidebar(savedState === 'true' || savedState === null);
            }
        };
        // 초기 설정
        checkMobile();
        // 리사이즈 이벤트 리스너
        window.addEventListener('resize', checkMobile);
        return function() {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);
    var toggleSidebar = function() {
        setShowSidebar(function(prev) {
            var newState = !prev;
            if (!isMobile) {
                localStorage.setItem('sidebar', newState.toString());
            }
            return newState;
        });
    };
    return {
        isMobile: isMobile,
        showSidebar: showSidebar,
        toggleSidebar: toggleSidebar,
        setShowSidebar: setShowSidebar
    };
}
